/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
let api_confs = {
    get_global_fields : {
        api_conf : {
            url : "/sainapse/irc/global_concepts",
            method : "post",
            data : {
                ic_name : ['props', 'ic_name'],
                version : ['props', 'version'],
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_random_groups : {
        api_conf : {
            url: "/sainapse/irc/groups_by_subset",
            method : "post",
            data : {
                ic_name : ['props', 'ic_name'],
                version : ['props', 'version'],
                subset_size : ['state', 'range_filter', 'range', 'upper'],
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_groups : {
        api_conf : {
            url: "/sainapse/irc/groups",
            method : "post",
            data : {
                ic_name : ['props', 'ic_name'],
                sort_by : ['state', 'range_filter', 'sort_by'],
                version : ['props', 'version'],
                lower_idx : ['state', 'range_filter', 'range', 'lower'],
                upper_idx : ['state', 'range_filter', 'range', 'upper'],
                //['state', 'report_info', 'report_summary', 'num_record_groups', 'value'],
                global_concept : 'None',
                step_tag : ['props', 'step_tag']
            }
        },
        result_to_state_map : [
            {
                result_key: ["data","result", "Result"],
                state_key : ["groups"]
            }
        ]
    },
    get_group_in_focus : {
        api_conf : {
            url : "/sainapse/irc/groups_by_id",
            method : "post",
            data : {
                ic_name : ['props', 'ic_name'],
                version : ['props', 'version'],
                group_ids : ['List', ['state', 'group_in_focus', 'group_id']],
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_groups_by_global_concept : {
        api_conf : {
            url : "/sainapse/irc/groups_by_global_concept",
            method : "post",
            data : {
                global_concept : ['state', 'global_concept'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_nearby_groups_for_group : {
        api_conf : {
            url : "/sainapse/irc/nearby_groups_for_group",
            method : "post",
            data : {
                group_id : ['state','group_in_focus','group_id'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                top_k : 25,
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_nearby_fields_for_group : {
        api_conf : {
            url : "/sainapse/irc/nearby_records_for_group",
            method : "post",
            data : {
                group_id : ['state','group_in_focus','group_id'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                top_k : 25,
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_nearby_groups_for_field : {
        api_conf : {
            url : "/sainapse/irc/nearby_groups_for_record",
            method : "post",
            data : {
                record_id : ['state','record_in_focus','record_id'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                top_k : 25,
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_nearby_fields_for_field : {
        api_conf : {
            url : "/sainapse/irc/nearby_records_for_record",
            method : "post",
            data : {
                record_id : ['state','record_in_focus','record_id'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                top_k : 25,
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_nearby_groups_for_global_field : {
        api_conf : {
            url : "/sainapse/irc/nearby_groups_for_record",
            method : "post",
            data : {
                record_id : ['state','global_record_in_focus'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                top_k : 25,
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_nearby_fields_for_global_field : {
        api_conf : {
            url : "/sainapse/irc/nearby_records_for_record",
            method : "post",
            data : {
                record_id : ['state','global_record_in_focus'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                top_k : 25,
                step_tag : ['props', 'step_tag']
            }
        }
    },
    get_singletons : {
        api_conf : {
            url : "/sainapse/irc/nearby_records_for_record",
            method : "post",
            data : {
                record_id : ['state','global_record_in_focus'],
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                top_k : 25,
                step_tag : ['props', 'step_tag']
            }
        }
    },
    search : {
        api_conf : {
            url : "/sainapse/irc/name_search",
            method : "post",
            data : {
                ic_name : ['props','ic_name'],
                version : ['props','version'],
                key : ['state','search_term'],
                columns : ['state','search_entities'],
                group_range : ['state','search_range_filter','group','list_range'],
                record_range : ['state','search_range_filter','record','list_range'],
                singleton_range : ['state','search_range_filter','singleton','list_range'],
                step_tag : ['props', 'step_tag']
            }
        }
    }
}

export default api_confs